import { createContext } from 'react';
import { IProduct } from '../types/Product';

const CartContext = createContext<{
  cartItems: IProduct[];
  cartTotalItems: number;
  cartTotalPrice: number;
  addToCart: (item: IProduct) => void;
  removeFromCart: (item: IProduct) => void;
}>({
  cartItems: [],
  cartTotalItems: 0,
  cartTotalPrice: 0,
  addToCart: () => {},
  removeFromCart: () => {},
});

export default CartContext;
